// extracted by mini-css-extract-plugin
export default {"instruction":"H9xOx","element":"Djpe6","providers":"FDehF","button":"epkz8"};